import type { PaymentProviderUiBehaviour } from '../provider-ui-behaviours';

export const EziDebitProviderUiBehaviour: PaymentProviderUiBehaviour = {
	resolveContact: (formContact, target) => {
		const firstName = formContact.firstName || target?.firstName || '';
		const lastName = formContact.lastName || target?.lastName || '';
		return {
			firstName,
			lastName,
			name: `${firstName} ${lastName}`.trim() || target?.name || '',
			email: formContact.email || target?.email || ''
		};
	},
	buildExtraSettings: contact => ({ email: contact.email ?? '', companyName: contact.companyName ?? '' }),
	supportsPricingSchedule: true
};
